module.exports = __webpack_public_path__ + "img/icon_huiyiyuyanhui_home.d71dfdbe.png";